module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "boradcast"
  }, [_c('Table', {
    attrs: {
      "loading": _vm.loading,
      "data": _vm.list,
      "columns": _vm.columns,
      "show-header": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('Page', {
    attrs: {
      "page-size": _vm.LIST_COUNT,
      "current": _vm.page,
      "total": _vm.total,
      "show-total": ""
    },
    on: {
      "on-change": _vm.changePage
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd288e18","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/notification/broadcast.vue
// module id = 905
// module chunks = 0